import script from "./TablePagination.vue?vue&type=script&setup=true&lang=js"
export * from "./TablePagination.vue?vue&type=script&setup=true&lang=js"

import "./TablePagination.vue?vue&type=style&index=0&id=f59ba682&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f59ba682"]])

export default __exports__